module.exports = __webpack_public_path__ + "static/media/4.900d56d4.jpg";